import { ActionTree } from 'vuex';
import { SubsidyState, RootState } from '../types';
import { state as authState } from '../auth/auth';
import { AxiosInstance, AxiosResponse } from 'axios';
import { handleAllErrors } from '@/utils/errorHandling';

export const actions: ActionTree<SubsidyState, RootState> = {
	async fetchSubsidies({ commit }): Promise<void> {
		const axiosInst: AxiosInstance = authState.axiosInst;

		try {
			const { data }: AxiosResponse = await axiosInst.get('/subsidies');
			commit('SET_SUBSIDIES', data);
		}
		catch (error) {
			handleAllErrors(error);
		}
	},

	async createSubsidy({}, subsidy: Subsidy): Promise<void> {
		const axiosInst: AxiosInstance = authState.axiosInst;
		try {
			await axiosInst.post('/subsidies', { ...subsidy, force_publish: true });
		}
		catch (error) {
			handleAllErrors(error);
		}
	},

	async updateSubsidy({}, subsidy: Subsidy): Promise<void> {
		const axiosInst: AxiosInstance = authState.axiosInst;
		try {
			await axiosInst.put(`/subsidies/${subsidy.id}`, { ...subsidy, force_publish: true });
		}
		catch (error) {
			handleAllErrors(error);
		}
	},

	async deleteSubsidy({}, id: number): Promise<void> {
		const axiosInst: AxiosInstance = authState.axiosInst;
		try {
			await axiosInst.delete(`/subsidies/${id}`, { data: { force_publish: true } });
		}
		catch (error) {
			handleAllErrors(error);
		}
	},

	async generateSubsidyCodes({}, { subsidyId, amount }: { subsidyId: number; amount: number }): Promise<void> {
		const axiosInst: AxiosInstance = authState.axiosInst;
		try {
			await axiosInst.post(`/subsidies/${subsidyId}/codes/generate`, { amount });
		}
		catch (error) {
			handleAllErrors(error);
		}
	},

	async deleteSubsidyCode({}, { subsidyId, codeId }: { subsidyId: number; codeId: number }): Promise<void> {
		const axiosInst: AxiosInstance = authState.axiosInst;
		try {
			await axiosInst.delete(`/subsidies/${subsidyId}/codes/${codeId}`);
		}
		catch (error) {
			handleAllErrors(error);
		}
	},

	async clearStudentsAndSubsidies({ dispatch }): Promise<void> {
		const axiosInst: AxiosInstance = authState.axiosInst;
		try {
			const { data }: AxiosResponse = await axiosInst.post('/subsidies/clear-school-data');
			// The codes are gone on the backend, so refresh the store to keep views from rendering the cleared codes.
			await dispatch('fetchSubsidies');
			return data;
		}
		catch (error) {
			handleAllErrors(error);
		}
	}
};